module.exports = __webpack_public_path__ + "static/media/logo_bugol.5d5b4c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_bugol.png
// module id = 441
// module chunks = 0